import { Injectable, InjectionToken } from '@angular/core';
import { UserSettingsDto } from '@elesgergo/ikont-web-client-sdk';
import { Observable } from 'rxjs';

interface Pageable<T> {
  list: T[];
  totalRecords: number;
}

export interface TableService {
  TABLE_SETTINGS_KEY: string;
  exportExampleFile(): Observable<object>;
  importFile(blob: Blob): Observable<object>;
  exportFailedUpload(issueId: number): Observable<object>;
  saveTableSettings(tableSettings: UserSettingsDto): Observable<object>;
  exportByFilter(filters: string): Observable<object>;
  exportByIds(ids: string[]): Observable<object>;
  getData(
    search: string | undefined,
    filter: string | undefined,
    pagination: string | undefined,
    sort: string | undefined
  ): Observable<unknown>;
  removeRows(ids: string): Observable<object>;
  getTableSettings(): Observable<UserSettingsDto | null>;
}

@Injectable()
export abstract class AbstractTableService<DataType> implements TableService {
  abstract TABLE_SETTINGS_KEY: string;
  abstract exportExampleFile(): Observable<object>;
  abstract importFile(blob: Blob): Observable<object>;
  abstract exportFailedUpload(issueId: number): Observable<object>;

  abstract saveTableSettings(
    tableSettings: UserSettingsDto
  ): Observable<object>;

  abstract exportByFilter(filters: string): Observable<object>;
  abstract exportByIds(ids: string[]): Observable<object>;

  abstract getData(
    search: string | undefined,
    filter: string | undefined,
    pagination: string | undefined,
    sort: string | undefined
  ): Observable<unknown>;

  abstract removeRows(ids: string): Observable<object>;
  abstract getTableSettings(): Observable<UserSettingsDto | null>;
}
